/* import __COLOCATED_TEMPLATE__ from './value-comparison.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();